export const BRAND = {
    name: "Dhanshree Constructions",
    nameShort: "DhanShree",
    logo: "https://nsppilefoundation.com/wp-content/uploads/2026/05/Group-26.png",
    whatsapp: "https://wa.me/916375428271",
    phone: "+91 63754 28271",
    phoneRaw: "6375428271",
    email: "support@dhanshreeconstructions.com",
    location: "Udaipur, Rajasthan, India",
};

export const NAV_LINKS = [
    { label: "About", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Process", href: "#process" },
    { label: "Packages", href: "#packages" },
    { label: "Gallery", href: "#gallery" },
];
